import { render } from "./ModalsNFTBoxCollab.vue?vue&type=template&id=06f9409b"
import script from "./ModalsNFTBoxCollab.vue?vue&type=script&lang=js"
export * from "./ModalsNFTBoxCollab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__